import {createActions} from 'client/framework';

const normalActions = [
  'CLEAR_TOAST_DATA',
  'DELETE_ASSIGNMENT',
  'RESET_STORE',
  'INITIALIZE_ASSIGNMENT_DRILLDOWN',
  'SET_TOAST_DATA'
];

export default createActions(null, normalActions);
